import React from 'react';
import classes from './HandlingUserData.module.css';

const es = (props) => (
  <div className={classes.Content}>
    {props.indexPage
      ? <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}><b>Descargar dato</b></p>
        <p>Para descargar sus datos vaya a la siguiente página<br />
          Configuración> Opciones> Gestión de datos> Descargar datos
        </p><br />
        <div className={classes.HrLine} />
        <br />
      </div>
      : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}><b>Solicitar eliminación de datos</b></p><br />
    <p>Para solicitar la eliminación de datos, siga los pasos a continuación:</p><br />
    <p>Ir a la página de contacto <br />
      Seleccione la opción "Eliminar cuenta y todos mis datos." <br />
      Presione Enviar<br /><br />
    </p>
    <p>Nuestro equipo de CS borrará todos sus datos en un plazo de 24 horas.</p>
  </div>
);

export default es;



// WEBPACK FOOTER //
// ./src/assets/localization/hud/es.js